import * as angular from "angular";
import {IController} from "angular";

export class PlanningRouteResourceSelectCtrl implements IController {

  routes: any;
  public searchTerm: string;

constructor(private $filter) {
}

  $onInit() {
    this.searchTerm = '';
  }

  public clearSearchTerm() {
    this.searchTerm = '';
  };
  $onChanges(onChangesObj: angular.IOnChangesObject) {
  }

  getSelectedResourceName(route){
    if (!route) {
      return this.$filter('translate')('Select Resource');
    }
    return route.resource.allocationName || route.resource.vehicleName;
  }
}

angular
  .module('bringoz.admin.planning')
  .component('planningRouteResourceSelect', {
    bindings: {
      routes: '<',
      onRouteSelected: '&',
    },
    template: require('./planning-route-resource-select.html').default,
    controller: PlanningRouteResourceSelectCtrl
  });
